import { Button, DrawerBody, DrawerFooter, Alert, Typography, } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { getWindow } from '../../../utils/general';
import '../../../styles/drawer.scss';
import { useExperienceContext } from '../../../hooks/useContexts';
export var EditDeliveryAddressSurvey = function (_a) {
    var _b;
    var closeDrawer = _a.closeDrawer, orderId = _a.orderId, fulfillmentGroup = _a.fulfillmentGroup, fulfillmentType = _a.fulfillmentType, orderDetailsData = _a.orderDetailsData, customerType = _a.customerType;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var isIos = (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.navigator.userAgent.includes('Mac');
    var isIosMobile = isIos && isConsumerApp;
    useEffect(function () {
        setTimeout(function () {
            var _a, _b, _c, _d;
            if (((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.QSI) && ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.QSI.API)) {
                (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.QSI.API.load();
                (_d = getWindow()) === null || _d === void 0 ? void 0 : _d.QSI.API.run();
            }
        }, 100);
    }, []);
    var renderSurvey = function () {
        var _a, _b, _c;
        return (React.createElement("div", null,
            React.createElement("input", { type: "hidden", id: "orderNumberForEditDA", value: orderId }),
            React.createElement("input", { type: "hidden", id: "orderOriginForEditDA", value: orderDetailsData.orderOrigin }),
            React.createElement("input", { type: "hidden", id: "salesDateForEditDA", value: orderDetailsData.salesDate }),
            React.createElement("input", { type: "hidden", id: "storeNumberForEditDA", value: orderDetailsData.storeNumber || '' }),
            React.createElement("input", { type: "hidden", id: "fulfillmentTypeForEditDA", value: fulfillmentType }),
            React.createElement("input", { type: "hidden", id: "customerTypeForEditDA", value: customerType }),
            React.createElement("input", { type: "hidden", id: "storeZipForEditDA", value: (_c = (_b = (_a = fulfillmentGroup.storePickup) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.zipCode }),
            React.createElement("input", { type: "hidden", id: "cityForEditDA", value: "New York" }),
            React.createElement("input", { type: "hidden", id: "stateForEditDA", value: "NY" }),
            React.createElement("input", { type: "hidden", id: "deliveryZipForEditDA", value: "NY" }),
            React.createElement("div", { id: "deliveryaddressXPsurvey", style: { display: 'block' } })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerBody, null,
            React.createElement(Alert, { status: "success" },
                React.createElement(Typography, null, "Your delivery address has been updated.")),
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
                React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-3" },
                    React.createElement(Typography, null,
                        "We have canceled the items in your original order #",
                        orderId,
                        "."),
                    React.createElement(Typography, null, "You\u2019ll get an email confirming the delivery of your items at your desired address.")),
                React.createElement(ErrorBoundary, { name: "edit-delivery-survey" }, renderSurvey()))),
        React.createElement(DrawerFooter, { className: "sui-bottom-auto sui-p-4" },
            React.createElement("div", { className: classNames('card-fix', {
                    'ios-bottom-fix': isIosMobile,
                }) },
                React.createElement(Button, { variant: "primary", onClick: closeDrawer }, "Go Back to Order Details")))));
};
